import NiceModal, { useModal } from '@ebay/nice-modal-react';

import { useState } from 'react';

import Button from 'components/field/Button';
import IntegerInput from 'components/field/IntegerInput';
import FormItem from 'components/form/FormItem';
import Modal from 'components/global/Modal';
import Typography from 'components/global/Typography';
import { ModalActions, ModalContent, ModalTitle } from 'components/global/styled/Modal.styled';

import useAlert from 'hooks/useAlert';
import useAxiosPrivate from 'hooks/useAxiosPrivate';

import { BRANCHES, WAREHOUSES } from 'services/consts';

import AppLogger from 'utils/AppLogger';

const UpdateRadiusForm = NiceModal.create(({ ids, mode, onSubmitResult }) => {
	const [km, setKm] = useState(null);
	const [isLoading, setIsLoading] = useState(false);
	const modal = useModal();
	const axiosPrivate = useAxiosPrivate();

	const { showSuccess, showError } = useAlert();

	const onSubmit = () => {
		setIsLoading(true);

		axiosPrivate
			.post(mode === 'warehouse' ? WAREHOUSES.UPDATE_WAREHOUSE_RADIUS : BRANCHES.UPDATE_BRANCH_RADIUS, {
				IDs: ids,
				servingRadius: km
			})
			.then((response) => {
				const { status } = response;

				if (status === 200) {
					if (response.data && response.data.success) {
						showSuccess();
						modal.remove();
						onSubmitResult(true);
					} else {
						showError();
						onSubmitResult(false);
					}
				}
			})
			.catch((error) => {
				showError();
				AppLogger.error(error);
				onSubmitResult(false);
			})
			.finally(() => setIsLoading(false));
	};

	return (
		<Modal fullwidth maxWidth="x-small" className="modal-serving-radius">
			<ModalTitle>
				<Typography variant="p1">updateServingRadius</Typography>
			</ModalTitle>
			<ModalContent>
				<FormItem label="servingRadius">
					<IntegerInput value={km} setValue={setKm} />
				</FormItem>
			</ModalContent>

			<ModalActions>
				<Button label="cancel" variant="outline" onClick={() => modal.remove()} />

				<Button
					loading={isLoading}
					onClick={onSubmit}
					disabled={!km}
					disabledTooltip={!km && 'formInfo.noChanges'}
					label={'update'}
				/>
			</ModalActions>
		</Modal>
	);
});

export default UpdateRadiusForm;
